module.exports = __webpack_public_path__ + "static/media/fonts_visual.9d4c4224.mp4";